import React from 'react';
import { Typography, Grid, Card, Avatar, Box } from '@mui/material';
import MainTitle from '../muiHome/mainTitle';
import CourseGrid from '../muiCommonComponent/coursesButtonGrid';
import { ListDataPresentation, ReactSlider, TableDataPresentation } from '../../utils/utils';
import ImagesSlider from '../muiCommonComponent/imageSlider';

function SOETContent() {
  const courses = [
    {name:'Diploma in Health Assistance  (DHA)',url:'/school-of-allied-health-sciences/dha'}, 
    {name:'Diploma In Medical Laboratory technology',url:'/school-of-allied-health-sciences/dmlt'},
    {name:'B.Sc. Biotechnology',url:'/school-of-allied-health-sciences/bsc-biotech'}, 
    {name:'B.Sc. in Medical laboratory technology',url:'/school-of-allied-health-sciences/bsc-mlt'},
    {name:'B.Sc.  in cardiovascular technology (CVT)',url:'/school-of-allied-health-sciences/bsct'}, 
    {name:'Bachelor of Physiotherapy (BPT)',url:'/school-of-allied-health-sciences/bpt'},    
    {name:'M.Sc. Microbiology',url:'/school-of-allied-health-sciences/msc-micro-bio'},
    {name:'M.Sc. MLT',url:'/school-of-allied-health-sciences/msc-mlt'},
    {name:'M.Sc. Biotechnology',url:''},
   
  ]; 
  const progHiglight=[
    {listName:'Availability of scholarships covering up to 100% of expenses for eligible students.'},
    {listName:'Successful job placement across diverse fields like medical biotechnology, Agriculture Biotechnology, Environment Biotechnology, Industrial Biotechnology, Bioinformatics, Genomics, Vaccinology and Allied Life Sciences streams such as Biochemistry, Genetics, Microbiology etc. showcasing a variety of opportunities with leading global corporations.'},
    {listName:'Employment opportunities in prestigious organizations across defence, research, government, healthcare, etc.'},
    {listName:'Partnerships providing skill-enhancement training to boost job readiness.'},
    {listName:'Prospects for advanced studies or research in both domestic and international institutions'},
    {listName:'Modern laboratories equipped with sophisticated instruments.'},
    {listName:'Choice-based Credit System in the curriculum.'},
    {listName:'Curriculum crafted by industry professionals and distinguished academics.'},
    {listName:'Emphasis on project-based and experiential learning methodologies'},
    {listName:'Access to e-learning platforms like MOOC, NPTEL, and Coursera'},
    {listName:'Tailored training programs to prepare students for placement opportunities.'},
    {listName:'Organizing conferences, short-term training, workshops, webinars, online coding contests, project contests, and industry internships'},
    {listName:'Advanced laboratories with full equipment.'},
    {listName:'Curriculum aligning with HCPC standards and offering industry-relevant elective.'},
    {listName:'courses.'},
    {listName:'Curriculum crafted by medical professionals and distinguished academics.'},
    {listName:'Partnerships providing skill-enhancement training to boost job readiness.'},
    {listName:'Access to e-learning platforms.'},
    {listName:'Tailored training programs to prepare students for placement opportunities.'},
    {listName:'Publication of over 70 research papers in both national and international journals and conferences.'},
    {listName:'Support for securing patents, copyrights, engaging in funded projects, consultancy, And launching student startups'},
    {listName:'Organizing conferences, short-term training, workshops, webinars, online webinar, online and offline various competitions, contests, project, and seminars at district, state and national level.'},
    {listName:'Emphasis on hands on training, case assessment and treatment.'},
    {listName:'Flexible credit system enabling students for higher post-graduation national and international studies.'},
    {listName:'Successful job placement in various hospitals and colleges.'},
    {listName:'Prospects for advanced studies or research in both domestic and international institutions.'},
    
   ]
   const departmentPoints=[
    {listName:'The department is well conceptualized and planned.'},
    {listName:'The department is abundantly enabled with the provision of rich resource centre in the form of -'},
   ]
   const departmentSubPoints=[
    {listName:'Modern laboratories'},
    {listName:'Experienced and well qualified faculty'},
    {listName:'Departmental library'},
    {listName:'Innovative teaching methodology.'},
   ]
   const eventGallery = [
    { img: '/assets/img/SAHS/event1.jpg' },
    { img: '/assets/img/SAHS/event2.jpg' },
    { img: '/assets/img/SAHS/event3.jpg' },
    { img: '/assets/img/SAHS/event4.jpg' },
    { img: '/assets/img/SAHS/event5.jpg' },
    { img: '/assets/img/SAHS/event6.jpg' },

    { img: '/assets/img/SAHS/event7.jpg' },
    { img: '/assets/img/SAHS/event8.jpg' },
    { img: '/assets/img/SAHS/event9.jpg' },
    { img: '/assets/img/SAHS/event10.jpg' },
    { img: '/assets/img/SAHS/event11.jpg' },
    { img: '/assets/img/SAHS/event12.jpg' },
    { img: '/assets/img/SAHS/event13.jpg' },
    
    // Add more logo URLs as needed
  ];
  const mediaGallery = [
    { img: '/assets/img/SAHS/media1.png' },
    { img: '/assets/img/SAHS/media2.png' },
    { img: '/assets/img/SAHS/media3.jpg' },
    { img: '/assets/img/SAHS/media4.jpg' },
    { img: '/assets/img/SAHS/media5.jpg' },
    // Add more logo URLs as needed
  ];
  const awardGallery = [
    { img: '/assets/img/SAHS/award.jpg' },
  ];
  const strength=[
    {listName:'Frequent Seminars/ Webinars/ Conference or Workshops led by the speakers of national and international repute.'},
    {listName:'Over 100 publications of our faculty at various national and international Journals indexed in SCI/ SCI-E/ Scopus/ PubMed and WoS'},
    {listName:'Exceptional placement records with a 90% placement rate among academia and Industry, globally.'},
    {listName:'Faculty representation at various scientific societies, academic and examination boards, further enriching our students learning experiences.'},
    {listName:'Vast research exposure of students in various laboratory/ industries/ research institute’s visit in frequent such as ICGEB, New Delhi, NBPGR, New Delhi & THSTI, Faridabad with reputed hospitals and early intervention centres.'},
    
    
   ]
   const partnerGallery = [
    { img: '/assets/img/SAHS/partner1.png' },
    { img: '/assets/img/SAHS/partner2.jpg' },
  ];
  const companyLogos = [
    {img:'/assets/img/SOPS/company1.png'},
    {img:'/assets/img/SOPS/company2.png'},
    {img:'/assets/img/SOPS/company3.png'},
    {img:'/assets/img/SOPS/company4.png'},
    {img:'/assets/img/SOPS/company5.jpg'},
    {img:'/assets/img/SOPS/company6.png'},
    {img:'/assets/img/SOPS/company7.png'},
    {img:'/assets/img/SOPS/company8.png'},
    {img:'/assets/img/SOPS/company9.jpg'},
    {img:'/assets/img/SOPS/company10.png'},
    // Add more logo URLs as needed
];
const studentsList = [
  {
      img: '/assets/img/student-testemonials-1.jpg',
      name: 'Vanshika',
      degree: 'B.Sc. Biotechnology Semester III',
      placement: '',
      description: 'My time at the Department of Biotechnology and Microbiology has consistently been engaging, enlightening, and enjoyable, enriched by excellent learning resources. The teaching faculty within the department is not only highly educated but also remarkably confident during lectures. Their approach makes learning a seamless, accessible, and applicable experience, incorporating futuristic and advanced learning tools. The department organizes a variety of events that blend fun and education seamlessly, providing an educational journey filled with joy and interest. I wholeheartedly recommend others to immerse themselves in the educational environment of MVN University to pave the way for a successful career.',
  },
  {
      img: '/assets/img/student-testemonials-2.jpg',
      name: 'Anjali',
      degree: 'M.Sc. Microbiology, Semester III',
      placement: '',
      description: 'MVN University is a vibrant institution offering abundant opportunities to embrace both the joys of life and the cutting-edge realms of biotechnology and microbiology. As a student with a keen interest in vaccine sciences, I consider myself fortunate to have gained admission to the microbiology program. This academic journey has allowed me to delve into the intricate workings of viruses and bacteria. The Department of Biotechnology and Microbiology, equipped with state-of-the-art labs, has turned my aspirations in medical microbiology into a reality. Engaging in advanced practical experiments in these well-equipped laboratories has been instrumental in shaping me into a confident microbiologist poised to contribute to our nation & well-being. I extend an invitation for you to be a part of this transformative experience.',
  },
  {
      img: '/assets/img/student-testemonials-3.jpg',
      name: 'Amrita',
      degree: 'BMLT, Semester 6',
      placement: '',
      description: "Hi! I am Amrita, a final-year BMLT student at MVN University. Being a BMLT student at MVN University has been an enriching journey. The comprehensive training in laboratory diagnostic procedures has equipped me with the skills needed to analyze medical specimens. I've learned to perform critical tests that contribute to accurate diagnoses. The faculty members are knowledgeable and supportive, guiding us through both theoretical concepts and practical applications. The state-of-the-art lab facilities provide an excellent learning environment. I'm confident that my education here will prepare me for a successful career in the field of medical laboratory technology.",
  },
  {
      img: '/assets/img/student-testemonials-4.jpg',
      name: 'Mohan ',
      degree: 'Mangla, BPT, Year 2nd',
      placement: '',
      description: 'I, Mohan Mangla, a second year BPT student at MVN University. I am happy in writing a testimonial for MVN Univesity! Here at MVN University learning is an exciting and rewarding experience. The Department of Physiotherapy here provides a holistic learning environment. The highly qualified faculty members are dedicated to imparting knowledge and practical skills. From understanding the intricacies of human anatomy to mastering therapeutic techniques, the curriculum is well-structured. The internship opportunities in multispecialty hospitals have given me valuable clinical exposure. I’m confident that my education at MVN University will prepare me for a successful career in physiotherapy.',
  },
  {
    img: '/assets/img/student-testemonials-5.jpg',
    name: 'Mansi',
    degree: 'BPT 4th Year',
    placement: '',
    description: 'MVN University stands out for its knowledgeable and supportive faculty, approachable professors, and a collaborative learning environment. The university fosters a strong sense of community and personal growth. With excellent mentorship and abundant resources, its the ideal place to learn, thrive, and build a successful career in physiotherapy.',
},
{
  img: '/assets/img/student-testemonials-6.jpg',
  name: 'Tanvi Gupta',
  degree: 'BPT 1st Year',
  placement: '',
  description: 'Hi, I’m Tanvi Gupta, a first-year BPT student at MVN University. Being here feels like being part of a family. This university has given me much more than just academic knowledge—it has helped me grow personally and professionally. From hands-on learning and real-life hospital exposure to state-of-the-art labs and constant faculty support, every aspect of the program pushes us to excel. Our professors are always there to guide us, making the learning journey truly enriching. Physiotherapy here isn’t just a course—it’s a path to making a real difference. If you’re passionate about helping others, MVN University is the perfect place to begin.',
},
{
  img: '/assets/img/student-testemonials-7.jpg',
  name: 'Kajal Chauhan',
  degree: 'B.Sc. CVT 1st Year',
  placement: '',
  description: 'As I embark on my journey pursuing a B.Sc. in Cardiovascular Technology, I am filled with gratitude and excitement. MVN University has provided me with exceptional faculty and a nurturing environment that supports both academic excellence and personal growth. I’m truly thankful to be part of this esteemed institution and look forward to contributing meaningfully to the field of cardiovascular technology.',
},
{
  img: '/assets/img/student-testemonials-81.jpg',
  name: 'Komal ',
  degree: 'M.Sc Microbiology, Semester IV',
  placement: '',
  description: "I'm thrilled to be a part of MVN University's Microbiology program. The faculty has been incredibly supportive, and the curriculum has provided me with a deep understanding of microbiology. The research opportunities have been amazing, and I'm excited to pursue a career in this field.",
},
  
];
const SAHSfeeStructureData = [
	{'Courses': 'Diploma in Health Assistant-DHA (After 10th Class)', 'eligibility ': '10th/10+2 with 50% marks', 'Duration': '3', 'Tuition Fee': '52000', 'Other Charges': '20000', '1st Year Onwards': '72000'},
	{'Courses': 'Diploma in Medical Lab Technology (DMLT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '2', 'Tuition Fee': '40000', 'Other Charges': '20000', '1st Year Onwards': '60000'},
	{'Courses': 'B.Sc in Medical Lab Technology (BMLT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '4', 'Tuition Fee': '62000', 'Other Charges': '20000', '1st Year Onwards': '82000'},
	{'Courses': 'B.Sc (Biotechnology)', 'eligibility ': '10+2 with 50% marks in PCB/M', 'Duration': '3', 'Tuition Fee': '47000', 'Other Charges': '20000', '1st Year Onwards': '67000'},
	{'Courses': '   B.Sc. in Cardiovascular Technology (CVT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '4', 'Tuition Fee': '72000', 'Other Charges': '20000', '1st Year Onwards': '92000'},
	{'Courses': 'Bachelor of Physiotherapy (BPT)', 'eligibility ': '10+2 with 50% marks in PCB and NEET(Age- 17 Years)', 'Duration': '5', 'Tuition Fee': '110000', 'Other Charges': '20000', '1st Year Onwards': '130000'},
	{'Courses': 'M.Sc Medical Lab Technology (M.Sc MLT)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'M.Sc (Microbiology)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'M.Sc. (Biotechnology)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'Note: BPT, BMLT & B.Sc CVT(Last 1 year Training)', 'eligibility ': '', 'Duration': '', 'Tuition Fee': '', 'Other Charges': '', '1st Year Onwards': ''},
];
const hostalFeeData=[
  {item:'Triple Seater (Non AC) with Meal','fee':'₹ 96000/-'},
  {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
]
const noteList=[
{listName:'1. Uniform fee Rs. 4500/- will be charged extra.'},
// {listName:'2. HSTES Counselling fee (B.Pharm) will be charged extra.'},
// {listName:'3. For Pharmacy courses eligibility verification is mandotory as per PCI norms and charges for the same will be charged extra.'},
{listName:'2. HSTES Counselling fee (B.Pharm) will be charged extra.'},
{listName:'3. For Pharmacy courses eligibility documents verification is mandatory as per PCI norms and charges for the same will be charged extra.'},
{listName:'4. UGC norms will be adhered for fee refund.'},
{listName:'5. Hostel/Transport Fee will be provided for full Academic year only.'},
{listName:'6. All the dispute are subjected to Palwal judiciary.'},
]
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="School of Allied Health Sciences" />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >The School of Allied Health Sciences at MVN University is committed to cultivating exceptionally proficient professionals across diverse domains of allied health professions including physiotherapy, biotechnology, microbiology, and allied health sciences. Our mission is to elevate and fortify modern and futuristic healthcare services across the globe through the training of allied health experts, emerging them from various social backgrounds with the attainment of the aim of equity and inclusiveness in holistic education for all. These professionals will serve as the cornerstone of the medical and health sectors of India and cross boundaries of countries for human welfare, playing an indispensable role in their advancement and efficacy of health sciences and towards the goals of sustainable development.
        <br/><br/>
        <b>A Noble Duty: Towards the service of humanity!</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <MainTitle title="DEPARTMENTS" />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <MainTitle title="Department of Physiotherapy" />
      </Grid>
      <Grid item xs={12} sm={12} md={ 12}>
        <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Department of Physiotherapy and rehabilitation of the individuals from various spheres of injuries or disabilities covering a wide range of spectrum from cardiopulmonary, IPD, orthopaedics, paediatrics, neurological, sports and many others offering bachelor’s in physiotherapy based on evidence based and research based informed teaching opening new doors of opportunities for the students. The OPD is well equipped with separate specialized departments of electrotherapy, exercise therapy, gym, rehabilitation, and occupational therapy departments. Various departments and equipment are separate for students and patients under specialized training and learning with experienced faculty. State of the OPD facilities with  specialization  in Sports, Neurological, Paediatrics, Cardiology, Geriatrics problems and sports injuries. Department of Physiotherapy, School of Allied Health Sciences have tie ups with various Hospitals of Palwal and Faridabad. Alumni students are well placed in different hospitals, clinics or have started their private practices.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <MainTitle title="Department of Medical Laboratory Technology" />
      </Grid>
      <Grid item xs={12} sm={12} md={ 12}>
        <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Department of Medical Lab Technology offers a comprehensive range of programs aimed at preparing students for careers in medical laboratory science. The curriculum covers a broad spectrum of topics including clinical laboratory tests, analysis of body matter, micro-organism screening, chemical analyses, and cell count. The practical training provided in laboratories gives students hands-on experience with various tests conducted in different laboratory settings such as Microbiology, Haematology, Cytology, Blood bank, Biochemistry, and Toxicology. This exposure ensures that students are well-equipped with the skills and knowledge needed to excel in their field upon graduation. The role of medical lab technicians and technologists in aiding doctors and medical microbiologists in detecting, diagnosing, and preventing diseases through clinical laboratory tests is crucial in the healthcare system. Their contribution helps in providing accurate and timely diagnoses, which is essential for effective treatment and disease prevention. Moreover, the emphasis on all-round development through a balanced blend of curricular and extracurricular activities ensures that students not only excel academically but also develop essential skills such as teamwork, communication, and leadership. The use of modern educational technology in classroom teaching enhances the learning experience and keeps students abreast of the latest advancements in the field. Overall, it seems like the Department of Medical Lab Technology is committed to providing high-quality education and training to produce competent and skilled professionals in the field of medical laboratory science.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <MainTitle title="Department of Biotechnology and Microbiology" />
      </Grid>
      <Grid item xs={12} sm={12} md={ 12}>
        <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        The Department of Biotechnology and Microbiology at MVN University is dedicated generating skilled human resources in biotechnology and microbiology, MVN University initiated undergraduate and postgraduate courses to cater to the educational needs of a large population in the National Capital Region (NCR) and surrounding areas, including the rural belt of southern Haryana in response to the pressing need for education. Since its inception, the department has undergone rapid evolution, attracting highly qualified faculty from prestigious universities to deliver quality education. The department boasts world-class infrastructure, featuring modern classrooms and well-equipped laboratories. These state-of-the-art laboratories house sophisticated instruments and various other essential tools for advanced research purposes.
        <br/>
        <br/>
         
        </Typography>
      </Grid>

      
      <Grid item xs={12} sm={12} md={12}>
              <MainTitle title="DEAN’S MESSAGE" />
            </Grid>
      
      <Grid item xs={12} sm={4} md={4}>
              <Card sx={{ height: 'auto', padding: '10px', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius: '10px' }}>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                  <Avatar alt={'NP'} src={'/assets/img/SOPS/ashutoshupadhayay.jpg'} sx={{ width: 150, height: 150, marginBottom: 2 }} />
                  <Box sx={{ background: '#ED1E24', borderRadius: '10px', padding: 2 }}>
                    <Typography fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" color={'#fff'}>
                    Dr. Ashutosh Upadhayay 
                    </Typography>
                    <Typography fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" color={'#fff'}>
                    Dean, School of Allied Health Sciences
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
             Welcome to the School of Allied Health Sciences at MVN University! <br/><br/>
              At the School of Allied Health Sciences, we are dedicated to nurturing the next generation of healthcare professionals in the field of Allied Health Scciences. Our programs are designed to provide students with the holistic development of students with practical knowledge and healthcare skills.  <br/><br/>
              With state-of-the-art facilities and a strong faculty of experienced professionals. We strive to offer an education that is both innovative and relevant to the ever-evolving healthcare industry. Our students benefit from an interdisciplinary approach to learning, engaging with real-world challenges. We have collaborations with ICAR-NBPGR New Delhi, THSTI Faridabad, Sarvodaya Hospital, Guru Nanak Hospital Palwal, Metro Hospital, Asian Hospital, Marengo Asia Hospital Faridabad. <br/><br/>
              We take pride in the achievements of our students and alumni, who continue to make a significant impact in their respective careers. Whether you're here to pursue undergraduate (UG) or postgraduate (PG & PhD) studies, we are committed to supporting your academic journey and personal growth. <br/><br/>
              I invite you to e learn more about our programs, research, and the opportunities we offer to help you build a successful career in allied health sciences. <br/><br/>
            
       
        
              </Typography>
            </Grid>
      


      
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="School of Allied Health Sciences Courses" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12} className="course-capitalize">
        <CourseGrid  courses={courses}/>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="PROGRAM HIGHLIGHTS" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ListDataPresentation DataList={progHiglight}/> 
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="Event & News Gallery" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <ImagesSlider imgArr={eventGallery} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="MEDIA COVERAGE" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <ImagesSlider imgArr={mediaGallery} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="AWARD HIGHLIGHTS" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <ImagesSlider imgArr={awardGallery} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="STRENGTHS OF SCHOOL OF ALLIED HEALTH SCIENCES" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
      <ListDataPresentation DataList={strength}/>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="KNOWLEDGE PARTNERS" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
      <ImagesSlider imgArr={partnerGallery} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="TOP RECRUITERS" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
      <ImagesSlider imgArr={companyLogos} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
          <MainTitle title="STUDENT TESTIMONIALS"/>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
          <ReactSlider cardList={studentsList}/>
      </Grid>
        <Grid item xs={12}>
					<MainTitle title='FEE STRUCTURE – 2026-27'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SAHSfeeStructureData}/>
				</Grid>
       
          <p>  <br/> Note: Only PCB should be considered as compulsory subjects</p>

        <Grid item xs={12}>
					<MainTitle title='Hostel Fees'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={hostalFeeData}/>
				</Grid>
				{/* <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable)
    </Typography>
    </Grid> */}
	<Grid item xs={12}>
    <MainTitle title="Notes" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={noteList}/>
     
    </Grid>
     <br/> <br/>
    </Grid>

    
  );
}

export default SOETContent;
